<template>
    <div class="flex flex-wrap">
        <div class="w-full text-center">
            <button
                ref="btnRef"
                v-on:mouseenter="toggleTooltip()"
                v-on:mouseleave="toggleTooltip()"
                type="button"
            >
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="14.899"
                    height="14.899"
                    viewBox="0 0 14.899 14.899"
                >
                    <g id="info_2_" data-name="info (2)" opacity="0.5">
                        <path
                            id="Path_25877"
                            data-name="Path 25877"
                            d="M7.45,0A7.45,7.45,0,1,0,14.9,7.45,7.45,7.45,0,0,0,7.45,0Zm0,13.658A6.208,6.208,0,1,1,13.658,7.45,6.208,6.208,0,0,1,7.45,13.658Z"
                            transform="translate(0 0)"
                        />
                        <path
                            id="Path_25878"
                            data-name="Path 25878"
                            d="M11.339,10h-.67a.67.67,0,1,0,0,1.339h.67v4.018a.67.67,0,0,0,1.339,0V11.339A1.339,1.339,0,0,0,11.339,10Z"
                            transform="translate(-3.89 -4.085)"
                        />
                        <ellipse
                            id="Ellipse_1216"
                            data-name="Ellipse 1216"
                            cx="1.005"
                            cy="1.005"
                            rx="1.005"
                            ry="1.005"
                            transform="translate(6.445 3.069)"
                        />
                    </g>
                </svg>
            </button>
            <div
                ref="tooltipRef"
                v-bind:class="{ hidden: !tooltipShow, block: tooltipShow }"
                class="border-0 mr-3 block z-50 font-normal leading-normal text-sm max-w-xs text-left no-underline break-words"
            >
                <div>
                    <div
                        class="bg-primary text-white font-bold px-3 p-2 mb-0 border-b border-white capitalize rounded-t-lg"
                    >
                        {{ title }}
                    </div>
                    <!-- #58a4a7 #7bb3b7 -->
                    <div class="text-black p-3 bg-inputbg rounded-b-lg">
                        {{ discription }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { createPopper } from "@popperjs/core";

export default {
    props: { title: "", discription: "" },
    data() {
        return {
            tooltipShow: false,
        };
    },
    methods: {
        toggleTooltip: function () {
            if (this.tooltipShow) {
                this.tooltipShow = false;
            } else {
                this.tooltipShow = true;
                createPopper(this.$refs.btnRef, this.$refs.tooltipRef, {
                    placement: "bottom",
                });
            }
        },
    },
};
</script>
